import videoThumbnail from '../images/gh-success-video-thumbnail.png';
import IosImg from '../images/gh-ios-download.jpeg';
import AndroidImg from '../images/gh-playstore-download.jpeg';
import DesktopDownloadImg from '../images/gh-desktop-download.jpeg';

import { PATH_PRODUCT_LOGIN, PATH_DESKTOP_DOWNLOAD, PATH_ANDROID_DOWNLOAD_PAGE, PATH_IOS_DOWNLOAD_PAGE } from '../utils/consts';

export const headerContent = {
    buy: {
        title: 'Thank you for choosing Grasshopper!',
        subtitle: "We're so excited to be part of your small business journey. Watch our short video for immediate next steps, and log into your account to get started."
    },
    trial: {
        title: 'Welcome to your Grasshopper trial!',
        subtitle: 'Check your inbox for a confirmation email from us.'
    }
};

export const blogCardsData = [
    {
        imgSrc: IosImg,
        imgAltText: 'Ios App Logo',
        href: PATH_IOS_DOWNLOAD_PAGE,
        title: 'iOS Users',
        callout: 'Get Connected',
        copy: "Be sure to visit the App Store to download Grasshopper's app, so that you’re always available whenever your customer calls. The mobile app is where all your calls, texts, voicemails, and faxes with customers will be housed."
    },
    {
        imgSrc: AndroidImg,
        imgAltText: 'Android App Logo',
        href: PATH_ANDROID_DOWNLOAD_PAGE,
        title: 'Android Users',
        callout: 'Get Connected',
        copy: "Be sure to visit the Google Play Store to download Grasshopper's app, so that you’re always available whenever your customer calls. The mobile app is where all your calls, texts, voicemails, and faxes with customers will be housed."
    },
    {
        imgSrc: DesktopDownloadImg,
        imgAltText: 'Grasshopper Desktop Apps Image',
        href: PATH_DESKTOP_DOWNLOAD(),
        title: 'Download the Desktop App',
        callout: 'Get Connected',
        copy: "Grasshopper is available as an app on your laptop, so whether you're at the desk or on-the-go, seamlessly communicate and connect with customers through your new business number on our apps."
    }
];

export const twoColData = {
    buy: {
        header: "Let's get you set up!",
        copy: 'Now that you’ve completed your purchase and selected a dedicated business phone number, there are 3 key steps to set you up for success:',
        href: PATH_PRODUCT_LOGIN,
        video: '2ILHpZi1X-I',
        videoThumbnailImg: videoThumbnail,
        // imgSrc: ,
        // imgAltText: '',
        ctaText: 'Log In',
        listContent: [
            'Log in to set-up your account call configuration',
            'Download the mobile and desktop apps',
            'Test your new number with an incoming and outgoing call'
        ]
    },
    trial: {
        header: "Let's get you set up!",
        copy: 'Now that you’ve started your trial and selected a dedicated business phone number, there are 3 key steps to set you up for success:',
        href: PATH_PRODUCT_LOGIN,
        video: '2ILHpZi1X-I',
        videoThumbnailImg: videoThumbnail,
        // imgSrc:,
        // imgAltText: '',
        ctaText: 'Log In',
        listContent: [
            'Log in to set-up your account call configuration',
            'Download the mobile and desktop apps',
            'Test your new number with an incoming and outgoing call'
        ]
    }
};
